import {Component, OnInit} from "@angular/core";
import {DocumentService} from "../../services/document.service";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {isUndefined} from "util";
import {Subject} from "rxjs/Subject";


@Component({
  templateUrl: "./generators.location-page.component.html"
})


export class GeneratorsLocationPageComponent implements OnInit {
  UI_TEXTS = UI_TEXTS;
  E_ENDPOINTS = E_ENDPOINTS;

  document: IDocument;
  private unsubscribe: Subject<void> = new Subject<void>();
  pageParams = paramsHelper.page()
    .setTitle("Генераторы");
  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.GENERATORS)
    .setDefaultListLabels()
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id"));


  constructor(private busService: BusService) {

  }

  ngOnInit(): void {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => this.document = e.document);
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/location/generators.location-page.component.ts